/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowDownRightSmall: {
  name: 'arrow_down_right_small';
  data: string;
} = {
  name: 'arrow_down_right_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.625 16a.75.75 0 1 1 0-1.5h3.814L7.967 9.027a.75.75 0 0 1 1.06-1.061l5.473 5.472V9.625a.75.75 0 0 1 1.5 0v5.624a.75.75 0 0 1-.75.75L9.624 16Z" fill="currentColor"/></svg>`
};
